import { useMemo, type ReactNode } from 'react';
import type {} from '@mui/material/themeCssVarsAugmentation'; // theme.vars ts error
import { ThemeProvider, createTheme } from '@mui/material/styles';

import { templateCustomizations } from '@/theme/customizations/template';
import { colorSchemes, typography, shadows, shape } from '@/theme/themePrimitives';
import { inputsCustomizations } from '@/theme/customizations/inputs';
import { dataDisplayCustomizations } from '@/theme/customizations/dataDisplay';
import { feedbackCustomizations } from '@/theme/customizations/feedback';
import { navigationCustomizations } from '@/theme/customizations/navigation';
import { surfacesCustomizations } from '@/theme/customizations/surfaces';
import { datePickersCustomizations } from '@/theme/customizations/datePickers';

interface AppThemeProps {
  children: ReactNode;
}

export default function AppTheme({ children }: AppThemeProps) {
  const theme = useMemo(
    () =>
      createTheme({
        // For more details about CSS variables configuration,
        // see https://mui.com/material-ui/customization/css-theme-variables/configuration/
        cssVariables: {
          colorSchemeSelector: 'data-mui-color-scheme',
          cssVarPrefix: 'template',
        },
        // Recently added in v6 for building light & dark mode app,
        // see https://mui.com/material-ui/customization/palette/#color-schemes
        colorSchemes,
        typography,
        shadows,
        shape,
        components: {
          ...inputsCustomizations,
          ...dataDisplayCustomizations,
          ...feedbackCustomizations,
          ...navigationCustomizations,
          ...surfacesCustomizations,
          ...datePickersCustomizations,
        },
        ...templateCustomizations,
      }),
    [],
  );

  return (
    <ThemeProvider defaultMode="light" theme={theme} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
